@if (initialized && projectWidgetData) {
    <mvs-widget
            [widgetData]="projectWidgetData"
            (onObjectSelect)="handleProjectSelect($event)"
    ></mvs-widget>
}
